import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { MultiDynamicField } from '../../../../../shared/types/assistant';
import { useEffect } from 'react';
import {
    ChatAssistant,
    InitialConfiguration,
} from '../../../../../shared/types/chat-assistant';

interface DomainAreasForm {
    [key: string]: MultiDynamicField[];
}

export const useDomainAreas = (chatAssistant: ChatAssistant) => {
    const formikDomainAreas = useFormik<DomainAreasForm>({
        initialValues,
        validationSchema,
        onSubmit: console.log,
    });

    useEffect(() => {
        if (chatAssistant) {
            formikDomainAreas.setValues({
                domainAreas:
                    (
                        chatAssistant?.initialConfiguration as InitialConfiguration
                    )?.domainAreas ?? initialValues.domainAreas,
            });
        }
    }, [chatAssistant]);

    return { formikDomainAreas };
};
